const baseUrl = 'https://chat-api.potados.com';

const Config = {
  baseUrl,

  urls: {
    usernameValidation: `${baseUrl}/validate/username`,
  },
};

export default Config;
